import React from "react";
import Pagination from "../../../components/Pagination";
import { useHomePageContext } from "../context/HomePageContext";
import { calculatePaginationTotalItems } from "../utils/projectUtils";

/**
 * PaginationSection component - Self-contained pagination display
 * Following Clean Code principle: Zero props, uses context for data access
 */
export const PaginationSection: React.FC = () => {
  const { projectData, uiState, actions } = useHomePageContext();

  const totalItems = calculatePaginationTotalItems(
    uiState.selectedProject,
    uiState.selectedRecommendation,
    projectData.forestationProjects.total,
    projectData.recommendedProjects.pagination?.total || 0,
    projectData.totalCounts?.searched,
  );

  return (
    <div className="mt-2 self-end">
      <Pagination
        page={uiState.pagination.page}
        totalItems={totalItems}
        itemsPerPage={uiState.pagination.perPage}
        onPageChange={actions.handlePageChange}
      />
    </div>
  );
};
